import React from 'react';
import { motion } from 'framer-motion';
import { ChoiceCue } from '../ChoiceCue';
import { expertQuestion } from '../../../data/snak';
const EASE = [0.23, 1, 0.32, 1] as const;
interface ExpertQuestionPageProps {
  selected: string | null;
  onSelect: (id: string) => void;
}
export function ExpertQuestionPage({
  selected,
  onSelect
}: ExpertQuestionPageProps) {
  return <div className="flex flex-1 flex-col justify-center px-10 py-8" data-id="element-191" data-mp="3gacuzkgft3h5">
      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="flex items-center gap-2.5 text-[10px] uppercase tracking-micro text-blue" data-id="element-192" data-mp="3gbnyrk9vub89">
        <span className="h-1.5 w-1.5 rounded-full bg-mint" aria-hidden="true" data-id="element-193" data-mp="32jhuowk07up6" />
        Your view first
      </motion.p>

      <motion.h2 initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      delay: 0.05,
      ease: EASE
    }} className="mt-5 max-w-3xl font-display text-[34px] font-semibold leading-[1.06] tracking-tight text-navy" data-id="element-194" data-mp="2xitsdeqbrrfn">
        {expertQuestion.cue.question}
      </motion.h2>

      <div className="mt-9" data-id="element-195" data-mp="1mqzzn2mb0cmw">
        <ChoiceCue cue={expertQuestion.cue} selected={selected} onSelect={onSelect} data-id="element-196" data-mp="1809ak2c3jrnh" />
      </div>

      <p className="mt-6 flex items-center gap-3 text-[12px] text-mut" data-id="element-197" data-mp="1cyu9zzjiy7av">
        <span className="h-px w-8 bg-line" aria-hidden="true" data-id="element-198" data-mp="1cwzpung2uj7u" />
        {expertQuestion.note}
      </p>
    </div>;
}